import React, { useEffect, useState } from 'react'
import { DemandType } from './DemandModal'
import ModalWrap from './index'
import Selector from './../Select/Select'
import { accountDocs } from './../../store/accountDocs'
import { SelectType } from '../../store/models'
import classes from './Modal.module.css'
import Input from './../Select/Input'
import BlueBtn from '../SidBarButtons/BlueBtn'
import { IoMdSave } from 'react-icons/io'
import http from './../../Service/http'
import Search from './../../block/ReactSearch'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { auth } from '../../store/auth'

function DocsRegisModal({ isOpen, setIsOpen, stud }: DemandType) {
	const [idStud, setIdStud] = useState<number>(0)
	const [docType, setDocType] = useState<SelectType>({
		value: 0,
		label: '',
		disabled: true
	})
	const [unigNum, setUnigNum] = useState<string>('')
	const [regNumber, setRegNumber] = useState<string>('')
	const [giveDate, setGiveDate] = useState<Date>(new Date())
	const notify = (title: string) => toast(title)
	const { t } = useTranslation()
	const changeIdStud = (param: number): void => {
		setIdStud(param)
	}

	useEffect(() => {
		if (isOpen && stud) {
			setIdStud(stud.id_student)
			const a = accountDocs.docsType.find(item => item.label == stud.akadem_document_type)
			setDocType({
				value: a ? a.value : 0,
				label: stud.akadem_document_type
			})
			setUnigNum(stud.document_numer)
			setRegNumber(stud.document_reg_numer)
			setGiveDate(new Date())
		} else {
			setIdStud(0)
			setDocType({
				value: 0,
				label: ''
			})
			setUnigNum('')
			setRegNumber('')
			setGiveDate(new Date())
		}
	}, [isOpen])

	return (
		<>
			<ModalWrap isOpen={isOpen} setIsOpen={setIsOpen} id={12} title={'Добавить новую'}>
				<div className={classes.account}>
					<Search changeIdStud={changeIdStud} s_fio={stud ? stud.s_fio : ''} />
					<div className='edit' style={{ width: '100%', padding: '0' }}>
						<Selector
							options={accountDocs.docsType}
							placeholder={'Выберите'}
							onChange={(e: SelectType) => {
								setDocType(e)
							}}
							value={docType}
							isSearchable={false}
							isDisabled={false}
							isClearable={false}
							title={t('st:modal.titles.doc')}
							name=''
							withBorder={true}
						/>
					</div>
					<div className='edit' style={{ width: '100%', padding: '0' }}>
						<Input
							style={{ minWidth: 120 }}
							title={t('st:modal.titles.uin')}
							type='text'
							placeholder='12335'
							value={unigNum}
							oninput={(str: string) => {
								setUnigNum(str)
							}}
						/>
						<Input
							style={{ minWidth: 120 }}
							title={t('st:modal.titles.regNum')}
							type='text'
							placeholder='12335'
							value={regNumber}
							oninput={(str: string) => {
								setRegNumber(str)
							}}
						/>
					</div>
					<Input
						title={t('st:modal.titles.dateIssue')}
						type='date'
						value={giveDate.toLocaleDateString().split('.').reverse().join('-')}
						oninput={(str: string) => {
							setGiveDate(new Date(str))
						}}
					/>
					<div className={classes.docRegisBtn}>
						<BlueBtn
							title={t('st:button.save')}
							onclick={async () => {
								if (!idStud) {
									return
								}
								if (!stud) {
									const a = await http.post('/regis/academDocRegTableInsert', {
										selected_id_student: idStud,
										id_academ_document_type: docType.value,
										new_uni_number: unigNum,
										new_reg_number: regNumber,
										give_date: giveDate,
										id_AVN_User: auth.user.data.id
									})
									if (a.data.result) {
										const getDocsType = async (id: number) => {
											const a = await http.post('/regis/academDocRegTable', {
												reportType: id,
												s_fio_document: null
											})
											accountDocs.newDocs(a.data.AcademDocRegTable)
										}
										getDocsType(docType.value)
										notify('Дабавлено!')
									}
								} else {
									const a = await http.put('/regis/academDocRegTableUpdate', {
										selected_id_student: idStud,
										id_academ_document_type: docType.value,
										new_uni_number: unigNum,
										new_reg_number: regNumber,
										give_date: giveDate,
										id_akadem_document: stud.id_akadem_document
									})
									if (a.data.result) {
										const getDocsType = async (id: number) => {
											const a = await http.post('/regis/academDocRegTable', {
												reportType: id,
												s_fio_document: null
											})
											accountDocs.newDocs(a.data.AcademDocRegTable)
										}
										getDocsType(docType.value)
										notify('Обновлено')
									}
								}
							}}
						>
							<IoMdSave />
						</BlueBtn>
					</div>
				</div>
			</ModalWrap>
		</>
	)
}

export default DocsRegisModal
